import {Workbook, Worksheet, WorksheetCell, WorksheetRow, WorksheetVisibility} from "igniteui-angular-excel";
import {ClsUtil} from "../../../util/cls-util";
import {ClsListaArchivos} from "../../../core/models/cls-storage";
import {ClsObjGenerico} from "../../util/cls-obj-generico";
import {inject} from "@angular/core";
import {AppPresupuestosService} from "../../../core/services/app-presupuestos.service";
import {EnumTipoParametro} from "../../../core/models/enum/enum-tipo-parametro";
import {ClsConfig} from "../../../util/cls-config";
import {AppInfoService} from "../../../core/services/app-info.service";
import {ClsObjCatalogoPresupuestosGenerales} from "../../cls-obj-catalogo-presupuestos-generales";
import {ClsObjManoDeObra} from "../menu-presupuesto/cls-obj-mano-de-obra";
import {
  ClsFactoresResultantes,
  ClsManoDeObraMoneda,
  ClsPorcentajesFASAR
} from "../../../core/models/cls-mano-de-obra";
import {ExcelUtility} from "../../../util/excel-utility";
import {ClsCatalogoCalculo, ClsCatalogoMOCalculo} from "../../../core/models/cls-calculo";
import {GenericoService} from "../../../core/services/generico.service";

export class ClsObjFasar extends ClsConfig {
  private mDecimalPorcentaje = 6;
  private mHashFactores: Map<number, ClsFactoresResultantes> = new Map<number, ClsFactoresResultantes>();
  // OBJ
  public mObjGenerico: ClsObjGenerico;
  public mHojaDatos: Worksheet;
  public mHojaUMA: Worksheet;
  public mHojaCamposGenerales: Worksheet;
  public mHojaTablaFactores: Worksheet;
  public mHojaSalarios: Worksheet;
  // public mHojaFasarIndividualJ8: Worksheet;
  // public mHojaFasarIndividualJHE: Worksheet;
  // PROPIEDADES
  private _MPATRONTRABAJADOR: boolean
  private _MESMONEDA1: boolean;
  private _MLIBRO: Workbook;
  // GENERALES
  private _MRIESGOTRABAJO: number;
  private _MSALARIOMINIMO: number;
  private _MUMA: number;
  private _MLIMITEGRUPO1: number;
  private _MLIMITEGRUPO2: number;
  private _MANOAPLICACION: number;
  // TRABAJADOR
  private _MPRESTACIONESESPECIET: number = 0;
  private _MPRESTACIONESDINEROT: number = 0;
  private _MINVALIDEZVIDAT: number = 0;
  private _MCESANTIAVEJEZT: number = 0;
  private _MGUARDERIAST: number = 0;
  private _MCUOTAFIJAT: number = 0;
  private _MEXCEDENTET: number = 0;
  // PATRON
  private _MPRESTACIONESESPECIEP: number;
  private _MPRESTACIONESDINEROP: number;
  private _MINVALIDEZVIDAP: number;
  private _MCESANTIAVEJEZP: number;
  private _MGUARDERIASP: number;
  private _MCUOTAFIJAP: number;
  private _MEXCEDENTEP: number;
  private _MOTROSCARGOSP: number;

  private _MNOMINAP: number;
  private _MSARP: number;
  private _MINFONAVITP: number;


  set MPATRONTRABAJADOR(value: boolean) {
    this._MPATRONTRABAJADOR = value;
  }

  get MPATRONTRABAJADOR(): boolean {
    return this._MPATRONTRABAJADOR;
  }

  set MESMONEDA1(value: boolean) {
    this._MESMONEDA1 = value;
  }

  get MESMONEDA1(): boolean {
    return this._MESMONEDA1;
  }

  set MLIBRO(value: Workbook) {
    this._MLIBRO = value;
  }

  get MLIBRO(): Workbook {
    return this._MLIBRO;
  }

  get MRIESGOTRABAJO(): number {
    return this._MRIESGOTRABAJO;
  }

  set MRIESGOTRABAJO(value: number) {
    value = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_RIESGO_TRABAJO', this.mDecimalPorcentaje, this.mObjGenerico, false, true)
    if (value > 100) {
      throw new Error(this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO').replace('{0}', this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.FASAR_RIESGO_TRABAJO')));
    }
    this._MRIESGOTRABAJO = value;
  }

  get MSALARIOMINIMO(): number {
    return this._MSALARIOMINIMO;
  }

  set MSALARIOMINIMO(value: number) {
    this._MSALARIOMINIMO = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_SALARIO_MINIMO', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MUMA(): number {
    return this._MUMA;
  }

  set MUMA(value: number) {
    this._MUMA = ClsUtil.verificaNumeroConExpresion(value, true, 'UMA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MLIMITEGRUPO1(): number {
    return this._MLIMITEGRUPO1;
  }

  set MLIMITEGRUPO1(value: number) {
    this._MLIMITEGRUPO1 = value;
  }

  get MLIMITEGRUPO2(): number {
    return this._MLIMITEGRUPO2;
  }

  set MLIMITEGRUPO2(value: number) {
    this._MLIMITEGRUPO2 = value;
  }

  set MANOAPLICACION(value: number) {
    this._MANOAPLICACION = value;
  }

  get MANOAPLICACION(): number {
    return this._MANOAPLICACION;
  }

  get MPRESTACIONESESPECIET(): number {
    return this._MPRESTACIONESESPECIET;
  }

  set MPRESTACIONESESPECIET(value: number) {
    this._MPRESTACIONESESPECIET = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_PRESTACIONES_ESPECIE', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MPRESTACIONESDINEROT(): number {
    return this._MPRESTACIONESDINEROT;
  }

  set MPRESTACIONESDINEROT(value: number) {
    this._MPRESTACIONESDINEROT = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_PRESTACIONES_DINERO', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MINVALIDEZVIDAT(): number {
    return this._MINVALIDEZVIDAT;
  }

  set MINVALIDEZVIDAT(value: number) {
    this._MINVALIDEZVIDAT = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_INVALIDEZ_VIDA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MCESANTIAVEJEZT(): number {
    return this._MCESANTIAVEJEZT;
  }

  set MCESANTIAVEJEZT(value: number) {
    this._MCESANTIAVEJEZT = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_CESANTIA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MGUARDERIAST(): number {
    return this._MGUARDERIAST;
  }

  set MGUARDERIAST(value: number) {
    this._MGUARDERIAST = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_GUARDERIA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MCUOTAFIJAT(): number {
    return this._MCUOTAFIJAT;
  }

  set MCUOTAFIJAT(value: number) {
    this._MCUOTAFIJAT = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_CUOTA_FIJA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MEXCEDENTET(): number {
    return this._MEXCEDENTET;
  }

  set MEXCEDENTET(value: number) {
    this._MEXCEDENTET = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_EXCEDENTE_3_UMA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MPRESTACIONESESPECIEP(): number {
    return this._MPRESTACIONESESPECIEP;
  }

  set MPRESTACIONESESPECIEP(value: number) {
    this._MPRESTACIONESESPECIEP = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_PRESTACIONES_ESPECIE', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MPRESTACIONESDINEROP(): number {
    return this._MPRESTACIONESDINEROP;
  }

  set MPRESTACIONESDINEROP(value: number) {
    this._MPRESTACIONESDINEROP = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_PRESTACIONES_DINERO', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MINVALIDEZVIDAP(): number {
    return this._MINVALIDEZVIDAP;
  }

  set MINVALIDEZVIDAP(value: number) {
    this._MINVALIDEZVIDAP = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_INVALIDEZ_VIDA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MCESANTIAVEJEZP(): number {
    return this._MCESANTIAVEJEZP;
  }

  set MCESANTIAVEJEZP(value: number) {
    this._MCESANTIAVEJEZP = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_CESANTIA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MGUARDERIASP(): number {
    return this._MGUARDERIASP;
  }

  set MGUARDERIASP(value: number) {
    this._MGUARDERIASP = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_GUARDERIA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MCUOTAFIJAP(): number {
    return this._MCUOTAFIJAP;
  }

  set MCUOTAFIJAP(value: number) {
    this._MCUOTAFIJAP = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_CUOTA_FIJA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MEXCEDENTEP(): number {
    return this._MEXCEDENTEP;
  }

  set MEXCEDENTEP(value: number) {
    this._MEXCEDENTEP = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_EXCEDENTE_3_UMA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MOTROSCARGOSP(): number {
    return this._MOTROSCARGOSP;
  }

  set MOTROSCARGOSP(value: number) {
    this._MOTROSCARGOSP = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_PRESTACIONES_ESPECIE', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
  }

  get MNOMINAP(): number {
    return this._MNOMINAP;
  }

  set MNOMINAP(value: number) {
    value = ClsUtil.verificaNumeroConExpresion(value, true, 'MENSAJES.GRALS.FASAR_IMPUESTO_NOMINA', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
    if (value > 100) {
      throw new Error(this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO').replace('{0}', this.mObjGenerico.getTranslationsSubject('MENSAJES.GRALS.FASAR_IMPUESTO_NOMINA')));
    }
    this._MNOMINAP = value;
  }

  get MSARP(): number {
    return this._MSARP;
  }

  set MSARP(value: number) {
    value = ClsUtil.verificaNumeroConExpresion(value, true, 'SAR', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
    if (value > 100) {
      throw new Error(this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO').replace('{0}', 'SAR'));
    }
    this._MSARP = value;
  }

  get MINFONAVITP(): number {
    return this._MINFONAVITP;
  }

  set MINFONAVITP(value: number) {
    value = ClsUtil.verificaNumeroConExpresion(value, true, 'INFONAVIT', this.mDecimalPorcentaje, this.mObjGenerico, false, true);
    if (value > 100) {
      throw new Error(this.mObjGenerico.getTranslationsSubject('MENSAJES.ALERT.VALIDAR_CAMPO').replace('{0}', 'INFONAVIT'));
    }
    this._MINFONAVITP = value;
  }

  public mObjMO: ClsObjManoDeObra = new ClsObjManoDeObra();
  private mObjCatalogoPptosGrals: ClsObjCatalogoPresupuestosGenerales = new ClsObjCatalogoPresupuestosGenerales();
  private infPpto = inject(AppPresupuestosService);
  private infApp = inject(AppInfoService);
  private servicioGen = inject(GenericoService);

  constructor() {
    super();
    this.mObjMO.mObjGenerico = this.mObjGenerico;
  }

  /**
   * Metodo para validar las hojas necesarias para realizar los calculos necesarios
   * @param file
   */
  public async validarHojasFasarSubirArchivoLocal(file: File) {
    try {
      const libro: any = await ExcelUtility.loadXLSX(file);
      const indexCamposGenerales: number = ExcelUtility.ubicaHojaXLSX(libro, 'N_Campos Generales');
      const indexTablaFactores: number = ExcelUtility.ubicaHojaXLSX(libro, 'a)TablaFactores');
      const indexDatos: number = ExcelUtility.ubicaHojaXLSX(libro, 'b) CapturaDatos');
      const indexSalarios: number = ExcelUtility.ubicaHojaXLSX(libro, 'd)Salarios');
      // const indexIndJNormal: number = ExcelUtility.ubicaHojaXLSX(libro, 'q)Fasar Individual_Jnormal');
      // const indexIndJExtra: number = ExcelUtility.ubicaHojaXLSX(libro, 'r)Fasar Individual_Jextra');

      // , indexIndJNormal, indexIndJExtra
      this.validarIndexHojasFasar(indexCamposGenerales, indexTablaFactores, indexDatos, indexSalarios);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public setHojasFasar() {
    try {
      const indexCamposGenerales: number = ClsUtil.ubicaHoja(this.MLIBRO, 'N_Campos Generales');
      const indexTablaFactores: number = ClsUtil.ubicaHoja(this.MLIBRO, 'a)TablaFactores');
      const indexDatos: number = ClsUtil.ubicaHoja(this.MLIBRO, 'b) CapturaDatos');
      const indexSalarios: number = ClsUtil.ubicaHoja(this.MLIBRO, 'd)Salarios');
      const indexIndJNormal: number = ClsUtil.ubicaHoja(this.MLIBRO, 'q)Fasar Individual_Jnormal');
      const indexIndJExtra: number = ClsUtil.ubicaHoja(this.MLIBRO, 'r)Fasar Individual_Jextra');
      const indexUMA: number = ClsUtil.ubicaHoja(this.MLIBRO, 'uma');

      // , indexIndJNormal, indexIndJExtra
      this.validarIndexHojasFasar(indexCamposGenerales, indexTablaFactores, indexDatos, indexSalarios);
      // OBTENEMOS LAS HIJAS
      this.mHojaUMA = this.MLIBRO.worksheets(indexUMA);
      this.mHojaCamposGenerales = this.MLIBRO.worksheets(indexCamposGenerales);
      this.mHojaTablaFactores = this.MLIBRO.worksheets(indexTablaFactores);
      this.mHojaDatos = this.MLIBRO.worksheets(indexDatos);
      this.mHojaSalarios = this.MLIBRO.worksheets(indexSalarios);
      // ocultar hojas ya que el fasar formato individual se trabajara con otra vista,
      if (indexIndJNormal !== -1) {
        this.MLIBRO.worksheets(indexIndJNormal).displayOptions.visibility = WorksheetVisibility.Hidden;
      }
      if (indexIndJExtra !== -1) {
        this.MLIBRO.worksheets(indexIndJExtra).displayOptions.visibility = WorksheetVisibility.Hidden;
      }

      // this.mHojaFasarIndividualJ8 = this.MLIBRO.worksheets(indexIndJNormal);
      // this.mHojaFasarIndividualJHE = this.MLIBRO.worksheets(indexIndJExtra);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private validarIndexHojasFasar(indexCamposGenerales: number, indexTablaFactores: number, indexDatos: number,
                                 indexSalarios: number) {
    // , indexIndJNormal: number, indexIndJExtra: number
    try {
      if (indexCamposGenerales === -1) {
        throw new Error('MENSAJES.ALERT.LIBRO_CAMPOS_GRALS');
      }
      if (indexTablaFactores === -1) {
        throw new Error('MENSAJES.ERROR.F_HOJA_CAPTURA_TABLA_FACTOR');
      }
      if (indexDatos === -1) {
        throw new Error('MENSAJES.ERROR.F_HOJA_CAPTURA_DATOS');
      }
      if (indexSalarios === -1) {
        throw new Error('MENSAJES.ERROR.F_HOJA_CAPTURA_SALARIO');
      }
      // if (indexIndJNormal === -1) {
      //   throw new Error('MENSAJES.ERROR.F_HOJA_CAPTURA_IND_JNORMAL');
      // }
      // if (indexIndJExtra === -1) {
      //   throw new Error('MENSAJES.ERROR.F_HOJA_CAPTURA_IND_JEXTRA');
      // }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public getValoresHojaFasarCalcular() {
    let indice: number = 0;
    let valueCelda: WorksheetCell;
    let filaTipo1: number = -1;
    let columnaTipo1: number = -1;
    let filaTipo2: number = -1;
    let columnaTipo2: number = -1;
    let filaTipo3: number = -1;
    let columnaTipo3: number = -1;
    let filaTipo4: number = -1;
    let columnaTipo4: number = -1;

    try {

      // Procesando las filas con valores
      const processRows = (fila: number, columna: number) => {
        try {
          while (this.mHojaSalarios.rows(fila).getCellValue(columna).toString().trim().length > 0) {
            let factores: ClsFactoresResultantes = new ClsFactoresResultantes();
            const row: WorksheetRow = this.mHojaSalarios.rows(fila);
            factores.Codigo = row.getCellValue(columna).toString().trim();
            factores.SalarioNominal = ClsUtil.redondearMoneda(ClsUtil.numberX(row.getCellValue(columna + 2).toString()), this.infPpto.decimalredondearimporte);
            factores.FactorSI = ClsUtil.redondearMoneda(ClsUtil.numberX(row.getCellValue(columna + 3).toString()), this.infPpto.decimalredondearmatrices);
            factores.Fasar = ClsUtil.redondearMoneda(ClsUtil.numberX(row.getCellValue(columna + 4).toString()), this.infPpto.decimalredondearmatrices);
            factores.SalarioReal = ClsUtil.redondearMoneda(ClsUtil.numberX(row.getCellValue(columna + 5).toString()), this.infPpto.decimalredondearimporte);

            this.mHashFactores.set(indice, factores);
            indice++;
            fila++;
          }
        } catch (ex) {
        }
      }

      // Obteniendo valores de la hoja "a)TablaFactores"
      this.MNOMINAP = this.getValorHoja(this.mHojaTablaFactores, 'NominaPatron') * 100;
      this.MOTROSCARGOSP = this.getValorHoja(this.mHojaTablaFactores, 'OtrosCargosPatron') * 100;
      this.MINFONAVITP = this.getValorHoja(this.mHojaTablaFactores, 'InfonavitPatron') * 100;
      this.MSARP = this.getValorHoja(this.mHojaTablaFactores, 'SarPatron') * 100;
      this.MSALARIOMINIMO = this.getValorHoja(this.mHojaTablaFactores, 'SMDF');
      this.MUMA = this.getValorHoja(this.mHojaUMA, 'UMA_CAP');

      // Se agrega try al obtener los valores de las celdas, porque no todos los documentos en las siguientes hojas
      // existen esos valores

      // JORNADALABORAL8HRS
      try {
        valueCelda = this.mHojaSalarios.getCell('JornadaLaboral8hrs');
        filaTipo1 = valueCelda.rowIndex;
        columnaTipo1 = valueCelda.columnIndex;
      } catch (e) {
      }

      // JORNADALABORALEXTRA
      try {
        valueCelda = this.mHojaSalarios.getCell('JornadaLaboralExtra');
        filaTipo2 = valueCelda.rowIndex;
        columnaTipo2 = valueCelda.columnIndex;
      } catch (e) {
      }

      // JORNADALABORAL28X14HRS
      try {
        valueCelda = this.mHojaSalarios.getCell('JornadaLaboral28X14hrs');
        filaTipo3 = valueCelda.rowIndex;
        columnaTipo3 = valueCelda.columnIndex;
      } catch (e) {
      }

      // JORNADALABORAL14X14HRS
      try {
        valueCelda = this.mHojaSalarios.getCell('JornadaLaboral14X14hrs');
        filaTipo4 = valueCelda.rowIndex;
        columnaTipo4 = valueCelda.columnIndex;
      } catch (e) {
      }

      // limpiar mapa para agregar nuevos registros
      this.mHashFactores.clear();

      // Inicia el procesamiento con los Salarios Normales
      if (columnaTipo1 >= 0) {
        processRows(filaTipo1, columnaTipo1);
      }

      // Jornadas con Horas Extras
      if (columnaTipo2 >= 0) {
        processRows(filaTipo2, columnaTipo2);
      }

      // Jornadas de 28 x 14
      if (columnaTipo3 >= 3) {
        processRows(filaTipo3, columnaTipo3);
      }

      // Jornadas de 14 x 14
      if (columnaTipo4 >= 0) {
        processRows(filaTipo4, columnaTipo4);
      }

    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async setValoresHojaFasarCalcular(): Promise<Workbook> {
    try {
      this.mObjMO.mObjGenerico = this.mObjGenerico;
      this.setHojasFasar();
      await this.limpiaEnviaParametrosGenerales();
      this.limpiarPorcentajesTablaFactores();
      this.vaciaPorcentajesTablaFactores();
      await this.vaciaDatosMO();
      // this.iniciaFasarIndividual();
      return this.MLIBRO;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private async limpiaEnviaParametrosGenerales() {
    try {
      // obtener map de campos generales
      await ClsUtil.obtenerEncabezadoReporte(this.infPpto, this.mObjCatalogoPptosGrals, this.mObjGenerico);
      // limpia todos los datos generales a la hoja de campos generales
      this.infPpto.mapCamposGenerales.forEach((value, key) => {
        this.validaCampoGeneral(key, '');
      });
      // envia todos los datos generales a la hoja de campos generales
      this.infPpto.mapCamposGenerales.forEach((value, key) => {
        this.validaCampoGeneral(key, value);
      });
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private validaCampoGeneral(nomParametro: string, valor: any) {
    try {
      this.mHojaCamposGenerales.getCell(nomParametro).value = valor;
    } catch (e) {
    }
  }

  private limpiarPorcentajesTablaFactores() {
    const campos = [
      "RiesgoTrabajo", "OtrosCargosPatron", "SMDF", "Limite_superior1", "Limite_superior2",
      "CuotaPatron", "CuotaTrabajador", "ExcedenteTrabajador", "ExcedentePatron",
      "DineroTrabajador", "DineroPatron", "InvalidezTrabajador", "InvalidezPatron",
      "CesantiaTrabajador", "CesantiaPatron", "GuarderiasTrabajador", "GuarderiaPatron",
      "NominaPatron", "InfonavitPatron", "SarPatron", "EspecieTrabajador", "EspeciePatron",
      "AnoAplicacion", "año_en_texto"
    ];

    campos.forEach(campo => this.setValorHoja(campo, 0));
  }

  private setValorHoja(nomParametro: string, valor: any) {
    try {
      this.mHojaTablaFactores.getCell(nomParametro).value = valor;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private getValorHoja(hoja: Worksheet, nomParametro: string) {
    try {
      return hoja.getCell(nomParametro).value;
    } catch (e) {
      return 0;
    }
  }

  private vaciaPorcentajesTablaFactores() {
    try {
      const campos = [
        {nombre: "RiesgoTrabajo", valor: this.MRIESGOTRABAJO / 100},
        {nombre: "SMDF", valor: this.MSALARIOMINIMO},
        {nombre: "Limite_superior1", valor: this.MLIMITEGRUPO1},
        {nombre: "Limite_superior2", valor: this.MLIMITEGRUPO2},
        {nombre: "AnoAplicacion", valor: this.MANOAPLICACION},
        {nombre: "año_en_texto", valor: this.MANOAPLICACION.toString()},
        {nombre: "OtrosCargosPatron", valor: this.MOTROSCARGOSP / 100}
      ];

      if (this.MPATRONTRABAJADOR) {
        campos.push(
          {nombre: "EspecieTrabajador", valor: this.MPRESTACIONESESPECIET / 100},
          {nombre: "DineroTrabajador", valor: this.MPRESTACIONESDINEROT / 100},
          {nombre: "InvalidezTrabajador", valor: this.MINVALIDEZVIDAT / 100},
          {nombre: "CesantiaTrabajador", valor: this.MCESANTIAVEJEZT / 100},
          {nombre: "GuarderiasTrabajador", valor: this.MGUARDERIAST / 100},
          {nombre: "CuotaTrabajador", valor: this.MCUOTAFIJAT / 100},
          {nombre: "ExcedenteTrabajador", valor: this.MEXCEDENTET / 100}
        );
      }

      campos.push(
        {nombre: "NominaPatron", valor: this.MNOMINAP / 100},
        {nombre: "InfonavitPatron", valor: this.MINFONAVITP / 100},
        {nombre: "SarPatron", valor: this.MSARP / 100},
        {nombre: "EspeciePatron", valor: this.MPRESTACIONESESPECIEP / 100},
        {nombre: "DineroPatron", valor: this.MPRESTACIONESDINEROP / 100},
        {nombre: "InvalidezPatron", valor: this.MINVALIDEZVIDAP / 100},
        {nombre: "CesantiaPatron", valor: this.MCESANTIAVEJEZP / 100},
        {nombre: "GuarderiaPatron", valor: this.MGUARDERIASP / 100},
        {nombre: "CuotaPatron", valor: this.MCUOTAFIJAP / 100},
        {nombre: "ExcedentePatron", valor: this.MEXCEDENTEP / 100}
      );

      // Aplicar los valores a la hoja
      ClsUtil.vaciaValorHoja(this.mHojaUMA, 'UMA_CAP', this.MUMA)
      campos.forEach(campo => ClsUtil.vaciaValorHoja(this.mHojaTablaFactores, campo.nombre, campo.valor));
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private obtenerPorcentajesTablaFactores(): ClsPorcentajesFASAR {
    try {
      const porcentajes: ClsPorcentajesFASAR = new ClsPorcentajesFASAR();
      porcentajes.mRiesgoTrabajo = this.MRIESGOTRABAJO / 100;
      porcentajes.mSalarioMinimo = this.MSALARIOMINIMO;
      porcentajes.mLimiteGrupo1 = this.MLIMITEGRUPO1;
      porcentajes.mLimiteGrupo2 = this.MLIMITEGRUPO2;
      porcentajes.mAnoAplicacion = this.MANOAPLICACION.toString();
      porcentajes.mOtrosCargosP = this.MOTROSCARGOSP / 100;
      if (this.MPATRONTRABAJADOR) {
        porcentajes.mPrestacionesEspecieT = this.MPRESTACIONESESPECIET / 100;
        porcentajes.mPrestacionesDineroT = this.MPRESTACIONESDINEROT / 100;
        porcentajes.mInvalidezVidaT = this.MINVALIDEZVIDAT / 100;
        porcentajes.mCesantiaVejezT = this.MCESANTIAVEJEZT / 100;
        porcentajes.mGuarderiasT = this.MGUARDERIAST / 100;
        porcentajes.mCuotaFijaT = this.MCUOTAFIJAT / 100;
        porcentajes.mExcedenteT = this.MEXCEDENTET / 100;
      }
      porcentajes.mNominaP = this.MNOMINAP / 100;
      porcentajes.mInfonavitP = this.MINFONAVITP / 100;
      porcentajes.mSarP = this.MSARP / 100;
      porcentajes.mPrestacionesEspecieP = this.MPRESTACIONESESPECIEP / 100;
      porcentajes.mPrestacionesDineroP = this.MPRESTACIONESDINEROP / 100;
      porcentajes.mInvalidezVidaP = this.MINVALIDEZVIDAP / 100;
      porcentajes.mCesantiaVejezP = this.MCESANTIAVEJEZP / 100;
      porcentajes.mGuarderiasP = this.MGUARDERIASP / 100;
      porcentajes.mCuotaFijaP = this.MCUOTAFIJAP / 100;
      porcentajes.mExcedenteP = this.MEXCEDENTEP / 100;
      porcentajes.mPrestacionesEspecieT = this.MUMA;
      return porcentajes;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private async vaciaDatosMO() {
    try {
      let valueCelda: WorksheetCell;
      let codigo: number = 0;
      let salarioNominal: number = 2;
      let descripcion: number = 1;
      let tipoFasar: number = -1;
      let filaTipo1: number = -1;
      let columnaTipo1: number = -1;
      let filaTipo2: number = -1;
      let columnaTipo2: number = -1;
      let filaTipo3: number = -1;
      let columnaTipo3: number = -1;
      let filaTipo4: number = -1;
      let columnaTipo4: number = -1;
      const dataMO: ClsManoDeObraMoneda[] = await this.mObjMO.crearObjMOEnBaseMonedaSeleccionada(this.MESMONEDA1);
      // Función auxiliar para setear valores a una fila y columna específicas
      const vaciaFilaColumna = (columna: number, fila: number, rowMO: ClsManoDeObraMoneda) => {
        if (columna >= 0) {
          const rows = this.mHojaSalarios.rows(fila);
          rows.setCellValue(codigo + columna, rowMO.Codigo);
          rows.setCellValue(salarioNominal + columna, ClsUtil.numberX(rowMO.SalarioBase));
          rows.setCellValue(descripcion + columna, rowMO.DescripcionLarga);
        }
      };
      // Se agrega try al obtener los valores de las celdas, porque no todos los documentos en las siguientes hojas
      // existen esos valores

      // JORNADALABORAL8HRS
      try {
        valueCelda = this.mHojaSalarios.getCell('JornadaLaboral8hrs');
        filaTipo1 = valueCelda.rowIndex;
        columnaTipo1 = valueCelda.columnIndex;
      } catch (e) {
      }

      // JORNADALABORALEXTRA
      try {
        valueCelda = this.mHojaSalarios.getCell('JornadaLaboralExtra');
        filaTipo2 = valueCelda.rowIndex;
        columnaTipo2 = valueCelda.columnIndex;
      } catch (e) {
      }

      // JORNADALABORAL28X14HRS
      try {
        valueCelda = this.mHojaSalarios.getCell('JornadaLaboral28X14hrs');
        filaTipo3 = valueCelda.rowIndex;
        columnaTipo3 = valueCelda.columnIndex;
      } catch (e) {
      }

      // JORNADALABORAL14X14HRS
      try {
        valueCelda = this.mHojaSalarios.getCell('JornadaLaboral14X14hrs');
        filaTipo4 = valueCelda.rowIndex;
        columnaTipo4 = valueCelda.columnIndex;
      } catch (e) {
      }

      // Tipo 1  "FASAR Jornada Normal"
      // Tipo 2  "FASAR Jornada con horas extras"
      // Tipo 3  "FASAR Jornada de 28 X 14"
      // Tipo 4  "FASAR Jornada de 14 X 14"
      this.limpiaDetalle(columnaTipo1, filaTipo1, columnaTipo2, filaTipo2, columnaTipo3, filaTipo3, columnaTipo4, filaTipo4);
      for (const rowMO of dataMO) {
        tipoFasar = rowMO.TipoFasar;
        switch (tipoFasar) {
          case 1:
            vaciaFilaColumna(columnaTipo1, filaTipo1++, rowMO);
            break;
          case 2:
            vaciaFilaColumna(columnaTipo2, filaTipo2++, rowMO);
            break;
          case 3:
            vaciaFilaColumna(columnaTipo3, filaTipo3++, rowMO);
            break;
          case 4:
            vaciaFilaColumna(columnaTipo4, filaTipo4++, rowMO);
            break;
        }
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  public async actualizarDatosMO(): Promise<ClsCatalogoCalculo[]> {
    let dataMO: ClsManoDeObraMoneda[] = [];
    let arrayRegGuardarMO: ClsCatalogoCalculo[] = [];
    try {
      if (this.mHashFactores.size > 0) {
        dataMO = await this.mObjMO.crearObjMOEnBaseMonedaSeleccionada(true);
        this.mHashFactores.forEach((value, key) => {
          const existeRegistro: ClsManoDeObraMoneda = dataMO.find(reg => reg.Codigo === value.Codigo);
          if (existeRegistro.SalarioReal !== value.SalarioReal) {
            const objRegGuardar: ClsCatalogoCalculo = new ClsCatalogoCalculo();
            let objCostoMO: ClsCatalogoMOCalculo = this.mObjMO.inicializarRegistroParaGuardar();
            const salarioBase: number = value.SalarioNominal;
            const factorSalarioIntegrado: number = value.FactorSI;
            const fasar: number = value.Fasar;
            const salarioIntegrado: number = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(salarioBase * factorSalarioIntegrado, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
            const salarioReal: number = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(salarioBase * fasar, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
            const sumaGastos: number = ClsUtil.redondearMoneda(existeRegistro.Viaticos + existeRegistro.AlimentacionHospedaje + existeRegistro.GastosSepelio + existeRegistro.OtrasPrestaciones, this.infPpto.decimalredondearimporte);
            const costoTotal = ClsUtil.redondearMoneda(ClsUtil.evaluadorExpresiones(salarioReal + sumaGastos, this.infPpto.decimalredondearimporte), this.infPpto.decimalredondearimporte);
            objRegGuardar.IdCatalogo = existeRegistro.IdCatalogo;
            objRegGuardar.Codigo = existeRegistro.Codigo;
            objRegGuardar.CostoTotal = costoTotal;
            objRegGuardar.JsonCatalogoCostosCalculo = '';
            objRegGuardar.CatalogoCostosCalculo = [];
            objRegGuardar.JsonCatalogoCostosOP = '';
            objRegGuardar.CatalogoCostosOP = [];
            objRegGuardar.JsonCatalogoMO = '';
            if (this.MESMONEDA1) {
              objCostoMO.SalarioBaseMoneda1 = salarioBase;
              objCostoMO.FactorSalarioIntegradoMoneda1 = factorSalarioIntegrado;
              objCostoMO.FasarMoneda1 = fasar;
              objCostoMO.SalarioIntegradoMoneda1 = salarioIntegrado;
              objCostoMO.SalarioRealMoneda1 = salarioReal;
              objCostoMO.ViaticosMoneda1 = existeRegistro.Viaticos;
              objCostoMO.AlimentacionYHospedajeMoneda1 = existeRegistro.AlimentacionHospedaje;
              objCostoMO.GastosDeSepelioMoneda1 = existeRegistro.GastosSepelio;
              objCostoMO.OtrasPrestacionesMoneda1 = existeRegistro.OtrasPrestaciones;
              objCostoMO.RiesgosdeTrabajoMoneda1 = existeRegistro.RiesgosDeTrabajo;
              objCostoMO.TipoFasarMoneda1 = existeRegistro.TipoFasar;
            } else {
              objCostoMO.SalarioBaseMoneda2 = salarioBase;
              objCostoMO.FactorSalarioIntegradoMoneda2 = factorSalarioIntegrado;
              objCostoMO.FasarMoneda2 = fasar;
              objCostoMO.SalarioIntegradoMoneda2 = salarioIntegrado;
              objCostoMO.SalarioRealMoneda2 = salarioReal;
              objCostoMO.ViaticosMoneda2 = existeRegistro.Viaticos;
              objCostoMO.AlimentacionYHospedajeMoneda2 = existeRegistro.AlimentacionHospedaje;
              objCostoMO.GastosDeSepelioMoneda2 = existeRegistro.GastosSepelio;
              objCostoMO.OtrasPrestacionesMoneda2 = existeRegistro.OtrasPrestaciones;
              objCostoMO.RiesgosdeTrabajoMoneda2 = existeRegistro.RiesgosDeTrabajo;
              objCostoMO.TipoFasarMoneda2 = existeRegistro.TipoFasar;
            }
            objRegGuardar.CatalogoMO = [objCostoMO];
            arrayRegGuardarMO.push(objRegGuardar);
          }
        });
      }
      return arrayRegGuardarMO;
    } catch (e) {
      throw new Error(e.message);
    }
  }

  private limpiaDetalle(columnaTipo1: number, filaTipo1: number, columnaTipo2: number, filaTipo2: number,
                        columnaTipo3: number, filaTipo3: number, columnaTipo4: number, filaTipo4: number): void {
    // Definir las columnas
    const codigo: number = 0;
    const salarioNominal: number = 2;
    const descripcion: number = 1;

    try {
      // Función auxiliar para limpiar una fila y columna específicas
      const limpiarFilaColumna = (columna: number, fila: number) => {
        if (columna >= 0) {
          const rows = this.mHojaSalarios.rows(fila);
          rows.setCellValue(codigo + columna, '');
          rows.setCellValue(salarioNominal + columna, 0);
          rows.setCellValue(descripcion + columna, '');
        }
      };
      // Iterar desde 0 hasta 500
      for (let i: number = 0; i <= 500; i++) {
        // Limpiar valores para el primer tipo de columna
        limpiarFilaColumna(columnaTipo1, filaTipo1++);
        // Limpiar valores para el segundo tipo de columna
        limpiarFilaColumna(columnaTipo2, filaTipo2++);
        // Limpiar valores para el tercer tipo de columna
        limpiarFilaColumna(columnaTipo3, filaTipo3++);
        // Limpiar valores para el cuarto tipo de columna
        limpiarFilaColumna(columnaTipo4, filaTipo4++);
      }
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // private iniciaFasarIndividual() {
  //   let region: WorksheetRegion;
  //   let filaTipo: number = -1;
  //   let columnaTipo: number = -1;
  //   try {
  //     // Se obtiene la fila y columna donde empezara a tomar los datos de las jornadas normales
  //     region = this.mHojaSalarios.getRegion('JornadaLaboral8hrs');
  //     filaTipo = region.firstRow;
  //     columnaTipo = region.firstColumn;
  //     // Se obtiene la fila y columna del rango del FasarIndividualJ8
  //     region = this.mHojaFasarIndividualJ8.getRegion('FasarIndividualJ8');
  //     this.limpiaHojaFasarIndividual(region, this.mHojaFasarIndividualJ8);
  //     this.mandarFasarIndividual(filaTipo, columnaTipo, 'CodigoFasarIndividualJ8', this.mHojaFasarIndividualJ8, this.mHojaFasarIndividualJ8.index, region);
  //   } catch (e) {
  //   }
  //
  //   try {
  //     // Se obtiene la fila y columna donde empezara a tomar los datos de las jornadas con horas extras
  //     region = this.mHojaSalarios.getRegion('JornadaLaboralExtra');
  //     filaTipo = region.firstRow;
  //     columnaTipo = region.firstColumn;
  //     // Se obtiene la fila y columna del rango del FasarIndividualJHE
  //     region = this.mHojaFasarIndividualJHE.getRegion('FasarIndividualJE');
  //     this.limpiaHojaFasarIndividual(region, this.mHojaFasarIndividualJHE);
  //     this.mandarFasarIndividual(filaTipo, columnaTipo, 'CodigoFasarIndividualJE', this.mHojaFasarIndividualJHE, this.mHojaFasarIndividualJHE.index, region);
  //   } catch (e) {
  //   }
  // }

  // private limpiaHojaFasarIndividual(rango: WorksheetRegion, hoja: Worksheet) {
  //   try {
  //     let region: WorksheetRegion = new WorksheetRegion(hoja, rango.firstRow, rango.firstColumn, rango.lastRow, rango.lastColumn);
  //     // hoja.deleteCells(region, false);
  //   } catch (e) {
  //     throw new Error(e.message);
  //   }
  // }
  //
  // private mandarFasarIndividual(fila: number, columna: number, nombreCeldaCodigo: string, hoja: Worksheet, indiceHoja: number, region: WorksheetRegion) {
  //
  // }

  public async guardarArchivoStorage(idPpto: bigint, listaFasar: ClsListaArchivos[], docSelec: ClsListaArchivos, nomArchivo: string, prefixMoneda: string) {
    // buscamos si hay algun archivo para la Moneda 1 o 2, dependiendo del prefixMoneda
    const hayArchivo: ClsListaArchivos = listaFasar.find(value => value.NombreArchivo.includes(prefixMoneda));
    if (!ClsUtil.esNulo(hayArchivo)) {
      const nomArchivo2 = `${this.gNomPrefixPptoFASAR}/${hayArchivo.Documento.replace(prefixMoneda, '')}${prefixMoneda}${hayArchivo.Extension}`;
      // verificar si es diferente el archivo de arriba con el nuevo para borrar el de arriba y guardar el nuevo
      // en caso de ser el mismo no se borra, ya que en el storage si se llama igual el archivo se reemplaza
      if (nomArchivo !== nomArchivo2) {
        await ClsUtil.borrarArchivoStorage(idPpto.toString(), nomArchivo2.split('/')[1], this.gNomBocketPpto, this.gNomPrefixPptoFASAR, this.mObjGenerico);
      }
    }
    await this.mObjGenerico.subirArchivosStorage(EnumTipoParametro.Presupuesto, this.gNomBocketPpto, nomArchivo, docSelec.ContenidoBase64, idPpto, docSelec.TipoArchivo);
  }

  public async inicializarValidarDatosSubirArchivoLocal(file: File, prefix: string, validarHojas = true): Promise<ClsListaArchivos> {
    try {
      if (validarHojas) {
        await this.validarHojasFasarSubirArchivoLocal(file);
      }
      return await ClsUtil.inicializarDatosSubirArchivoLocal(file, prefix);
    } catch (e) {
      throw new Error(e.message);
    }
  }

  // public async previewFASARIndividual(esMoneda1: boolean, ContenidoBase64: string): Promise<ClsDocumentosFASAR> {
  //   try {
  //     // obtener map de campos generales, para eso tenemos que obtener los encabezados
  //     await ClsUtil.obtenerEncabezadoReporte(this.infPpto, this.mObjCatalogoPptosGrals, this.mObjGenerico);
  //     const paramGrals: Map<string, any> = this.infPpto.mapCamposGenerales;
  //     this.mObjMO.mObjGenerico = this.mObjGenerico;
  //     const dataMO: ClsManoDeObraMoneda[] = await this.mObjMO.crearObjMOEnBaseMonedaSeleccionada(esMoneda1);
  //     const porcentajes: ClsPorcentajesFASAR = this.obtenerPorcentajesTablaFactores();
  //     return await this.generarFASARIndividual(paramGrals, porcentajes, dataMO, ContenidoBase64);
  //   } catch (e) {
  //     throw new Error(e.message);
  //   }
  // }

  // private async generarFASARIndividual(paramGrals: Map<string, any>, porcentajes: ClsPorcentajesFASAR, datosMO: ClsManoDeObraMoneda[], ContenidoBase64: string): Promise<ClsDocumentosFASAR> {
  //   let respuesta: ClsDocumentosFASAR;
  //   const objPeticion: ClsPeticionFASARIndividual = new ClsPeticionFASARIndividual();
  //   objPeticion.AccessToken = ClsUtil.obtenerAccessToken(this.infApp);
  //   // Convertir el Map a un objeto JSON
  //   objPeticion.ParametrosGenerales = Object.fromEntries(paramGrals);
  //   objPeticion.DatosPorcentajes = porcentajes;
  //   objPeticion.DatosMO = datosMO;
  //   objPeticion.DocumentoBase64 = ContenidoBase64;
  //   respuesta = await this.servicioGen.enviarPeticionCloudRunNET(objPeticion, 'RptFasar/GeneraReporteFasar')
  //     .then(async (resp: any) => {
  //       const resp2: ClsRespuestaFASARIndividual = ClsUtil.parseJSONBig(resp);
  //       try {
  //         if (!ClsUtil.esNulo(resp2.errores) && resp2.errores.errorDescripcion !== '') {
  //           throw new Error(resp2.errores.errorDescripcion);
  //         } else {
  //           respuesta = new ClsDocumentosFASAR();
  //           respuesta.fasarIndividualJExtra = resp2.fasarIndividualJExtra;
  //           respuesta.fasarIndividualJNormal = resp2.fasarIndividualJNormal;
  //           return respuesta;
  //         }
  //       } catch (e) {
  //         throw new Error(e.message);
  //       }
  //     });
  //   return respuesta;
  // }
}
